import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		}
	}
}